import { UrlMatcher, UrlMatchResult, UrlSegment } from '@angular/router';
import { STANDARD_REMOTE_URL_PREFIX } from '../consts';

export function isUrlOfStandardRemoteApplication(): UrlMatcher {
	return (url: UrlSegment[]): UrlMatchResult | null => {
		const fullUrl = url.map((u) => u.path).join('/');
		if (fullUrl.startsWith(STANDARD_REMOTE_URL_PREFIX)) {
			const res: UrlMatchResult = { consumed: url };
			if (url.length > 1) {
				res.posParams = {
					appId: url[1],
				};
			}
			return res;
		}
		return null;
	};
}
